import type { BaseError as ViemBaseError } from "viem"
import { InternalRpcError } from "viem"
import type { BaseError as WagmiBaseError } from "wagmi"
import { walk } from "./walk"

export function isInternalWalletError(
  error: WagmiBaseError | ViemBaseError,
): boolean {
  return !!walk(error, e => e instanceof InternalRpcError)
}
